(function() {
  // Select the cart total element
  const cartTotal = document.querySelector('.saw-cart-total.cart_subtotal');
  
  if (!cartTotal) return;

  // Function to format value with 2 decimal places
  function formatPrice(value) {
    return '$' + parseFloat(value).toFixed(2);
  }

  // MutationObserver to watch for text changes
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        const rawText = cartTotal.textContent.trim();
        
        // Strip currency symbol and parse number
        const numericValue = parseFloat(rawText.replace(/[^0-9.]/g, ''));
        
        if (!isNaN(numericValue) && numericValue > 0) {
          const formatted = formatPrice(numericValue);
          
          // Only update if not already formatted correctly
          if (cartTotal.textContent.trim() !== formatted) {
            cartTotal.textContent = formatted;
          }
        }
      }
    });
  });

  // Observe the element for text content changes
  observer.observe(cartTotal, {
    childList: true,
    characterData: true,
    subtree: true
  });

  // Also handle initial page load if value already > 0
  const initialValue = parseFloat(cartTotal.textContent.replace(/[^0-9.]/g, ''));
  if (!isNaN(initialValue) && initialValue > 0) {
    cartTotal.textContent = formatPrice(initialValue);
  }
})();